import { state } from '../state'
import { cache } from './cache'
import { ensureById } from './entity-service'

export async function ensurePlayerTechniques(techniqueIds: string[]) {
  const loaded = await ensureById('PlayerTechnique', state.playerTechniques, techniqueIds)
  await cache.setItems(loaded)
}
